var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9052 16.1133C12.3682 16.1133 12.8122 16.2972 13.1396 16.6246C13.467 16.952 13.651 17.3961 13.651 17.8591V20.4968H10.3442V17.6742C10.3442 17.4692 10.3846 17.2662 10.4631 17.0768C10.5415 16.8874 10.6565 16.7154 10.8014 16.5704C10.9464 16.4255 11.1185 16.3105 11.3078 16.2321C11.4972 16.1536 11.7002 16.1133 11.9052 16.1133Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98412 3.47266H15.707C16.0676 3.47266 16.4134 3.61591 16.6684 3.8709C16.9234 4.12589 17.0667 4.47173 17.0667 4.83234V20.5754H6.90723V4.5495C6.90723 4.40808 6.93508 4.26805 6.9892 4.1374C7.04332 4.00675 7.12265 3.88803 7.22265 3.78804C7.32265 3.68804 7.44136 3.60872 7.57202 3.55461C7.70267 3.5005 7.84271 3.47265 7.98412 3.47266Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4146 6.82422H20.7629C21.0431 6.82422 21.3206 6.87941 21.5795 6.98664C21.8384 7.09387 22.0736 7.25105 22.2717 7.44919C22.4699 7.64733 22.627 7.88255 22.7343 8.14143C22.8415 8.40031 22.8967 8.67778 22.8967 8.95799V18.443C22.8967 18.7232 22.8415 19.0007 22.7343 19.2596C22.627 19.5184 22.4699 19.7537 22.2717 19.9518C22.0736 20.1499 21.8384 20.3071 21.5795 20.4143C21.3206 20.5216 21.0431 20.5768 20.7629 20.5768H17.4146V6.82422Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3724 9.67969H22.3872C22.4344 9.67969 22.4795 9.6984 22.5129 9.73172C22.5462 9.76504 22.5649 9.81022 22.5649 9.85734V10.742C22.5649 10.7891 22.5462 10.8343 22.5129 10.8676C22.4795 10.9009 22.4344 10.9197 22.3872 10.9197H19.3724C19.208 10.9197 19.0503 10.8543 18.934 10.7381C18.8178 10.6218 18.7524 10.4641 18.7524 10.2997C18.7524 10.1352 18.8178 9.97755 18.934 9.86128C19.0503 9.74501 19.208 9.67969 19.3724 9.67969Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3724 13.0801H22.3872C22.4344 13.0801 22.4795 13.0988 22.5129 13.1321C22.5462 13.1654 22.5649 13.2106 22.5649 13.2577V14.1424C22.5649 14.1895 22.5462 14.2347 22.5129 14.268C22.4795 14.3013 22.4344 14.32 22.3872 14.32H19.3724C19.208 14.32 19.0503 14.2547 18.934 14.1385C18.8178 14.0222 18.7524 13.8645 18.7524 13.7001C18.7524 13.5356 18.8178 13.3779 18.934 13.2617C19.0503 13.1454 19.208 13.0801 19.3724 13.0801Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.55811 20.5762H3.20973C2.92949 20.5762 2.652 20.521 2.39311 20.4137C2.13421 20.3065 1.89897 20.1493 1.70083 19.9511C1.50269 19.7529 1.34552 19.5177 1.2383 19.2588C1.13109 18.9999 1.07592 18.7224 1.07595 18.4421L1.07595 8.95739C1.07595 8.67717 1.13113 8.3997 1.23836 8.14082C1.34559 7.88193 1.50276 7.6467 1.7009 7.44855C1.89904 7.25041 2.13427 7.09323 2.39315 6.98599C2.65204 6.87876 2.92951 6.82356 3.20973 6.82356H6.55811L6.55811 20.5762Z",
    stroke: "#E5E7EB",
    strokeWidth: 1.20362,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60023 10.918H1.58542C1.5383 10.918 1.49311 10.8993 1.4598 10.8659C1.42648 10.8326 1.40777 10.7874 1.40777 10.7403V9.85565C1.40777 9.80853 1.42648 9.76335 1.4598 9.73003C1.49311 9.69671 1.5383 9.678 1.58542 9.678H4.60023C4.68165 9.678 4.76227 9.69403 4.83749 9.72519C4.91271 9.75635 4.98105 9.80202 5.03863 9.85959C5.0962 9.91716 5.14186 9.98551 5.17302 10.0607C5.20418 10.1359 5.22021 10.2166 5.22021 10.298C5.22021 10.4624 5.1549 10.6201 5.03863 10.7364C4.92236 10.8526 4.76466 10.918 4.60023 10.918Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60023 14.3203H1.58542C1.5383 14.3203 1.49311 14.3016 1.4598 14.2683C1.42648 14.235 1.40777 14.1898 1.40777 14.1427V13.258C1.40777 13.2109 1.42648 13.1657 1.4598 13.1324C1.49311 13.0991 1.5383 13.0803 1.58542 13.0803H4.60023C4.76466 13.0803 4.92236 13.1457 5.03863 13.2619C5.1549 13.3782 5.22021 13.5359 5.22021 13.7003C5.22021 13.8648 5.1549 14.0225 5.03863 14.1387C4.92236 14.255 4.76466 14.3203 4.60023 14.3203Z",
    fill: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.791 6.4525H12.1826V6.5495H13.4407V5.9639C13.4407 5.73312 13.3491 5.51179 13.1859 5.34861C13.0227 5.18543 12.8014 5.09375 12.5706 5.09375H11.4103C11.2961 5.09373 11.1829 5.11622 11.0773 5.15994C10.9717 5.20366 10.8758 5.26775 10.795 5.34856C10.7141 5.42936 10.65 5.52529 10.6063 5.63087C10.5626 5.73645 10.54 5.84962 10.54 5.9639V6.5495H11.7909L11.791 6.4525Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 9.54632H11.791V9.44922H10.54V10.0348C10.54 10.2656 10.6317 10.4869 10.7949 10.6501C10.9581 10.8133 11.1794 10.905 11.4102 10.905H12.5705C12.6848 10.905 12.7979 10.8825 12.9035 10.8387C13.0091 10.795 13.105 10.7309 13.1858 10.6501C13.2666 10.5693 13.3307 10.4733 13.3744 10.3678C13.4181 10.2622 13.4406 10.149 13.4406 10.0348V9.44922H12.1826V9.54632Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.026 6.54883H13.4404V7.80332H13.5338V8.19493H13.4404V9.44932H14.026C14.1403 9.44932 14.2535 9.42681 14.359 9.38308C14.4646 9.33935 14.5605 9.27525 14.6413 9.19444C14.7221 9.11364 14.7862 9.01771 14.83 8.91213C14.8737 8.80655 14.8962 8.6934 14.8962 8.57912V7.41898C14.8962 7.1882 14.8045 6.96687 14.6413 6.80369C14.4781 6.6405 14.2568 6.54883 14.026 6.54883Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4396 8.19493V7.80332H10.5401V6.54883H9.95467C9.8404 6.54882 9.72724 6.57132 9.62167 6.61505C9.51609 6.65878 9.42016 6.72287 9.33935 6.80367C9.25855 6.88447 9.19445 6.9804 9.15071 7.08597C9.10698 7.19155 9.08447 7.3047 9.08447 7.41898V8.57923C9.0845 8.81 9.17619 9.03131 9.33938 9.19448C9.50258 9.35765 9.7239 9.44932 9.95467 9.44932H10.5401V8.19493H10.4396Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1826 7.65031C12.2473 7.68607 12.3008 7.73903 12.3372 7.80332H13.4407V6.54883H12.1826V7.65031Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6437 7.80332C11.6787 7.7415 11.7296 7.69012 11.791 7.65446V6.54883H10.54V7.80332H11.6437Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.791 8.34412C11.7296 8.30848 11.6787 8.25712 11.6437 8.19531H10.54V9.4497H11.7909L11.791 8.34412Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3372 8.19531C12.3008 8.25961 12.2473 8.31257 12.1826 8.34832V9.4497H13.4407V8.19531H12.3372Z",
    fill: "#E5E7EB",
    stroke: "#E5E7EB",
    strokeWidth: 0.00523314,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.0138,
    height: 18.2957,
    fill: "white",
    transform: "translate(0.479492 2.87695)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacilities);
export default __webpack_public_path__ + "static/media/facilities.3a45f2edb871c11bff5a67b629264cee.svg";
export { ForwardRef as ReactComponent };